import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Share.module.css';
import useStore from '../../../../hooks/useStore';
import shareImage from './mino_revolution.png';
import QRCode from 'qrcode';

const Share = ({ onClose }) => {
  const navigate = useNavigate();
  const { userStatus, getReferralLink, copyReferralLink, copied } = useStore();
  const [compositeImage, setCompositeImage] = useState(null);
  const [qrCodeGenerated, setQrCodeGenerated] = useState(false);
  const canvasRef = useRef(null);
  const imageRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  
  const referralLink = getReferralLink();

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isMobileDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
    setIsMobile(isMobileDevice);

    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.src = shareImage;
    img.onload = () => {
      if (canvasRef.current) {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        
        canvas.width = img.width;
        canvas.height = img.height;
        
        ctx.drawImage(img, 0, 0);
        
        generateQRCode(canvas, img, referralLink);
      }
    };
  }, [referralLink]);

  const generateQRCode = (canvas, img, link) => {
    const qrSize = Math.floor(img.width * 0.2);
    const padding = Math.floor(img.width * 0.06);
    
    QRCode.toCanvas(
      document.createElement('canvas'), 
      link, 
      {
        width: qrSize,
        margin: 0,
        color: {
          dark: '#000000ff',
          light: '#ffffffff'
        }
      }, 
      (err, qrCanvas) => {
        if (!err) {
          const ctx = canvas.getContext('2d');
          
          ctx.drawImage(
            qrCanvas, 
            img.width - qrSize - padding, 
            img.height - qrSize - padding
          );
          
          setCompositeImage(canvas.toDataURL('image/png'));
          setQrCodeGenerated(true);
        }
      }
    );
  };

  const handleCopy = () => {
    copyReferralLink();
  };

  const handleSaveImage = () => {
    if (compositeImage) {
      if (isMobile) {
        window.open(compositeImage, '_blank');
      } else {
        const link = document.createElement('a');
        link.href = compositeImage;
        link.download = 'mino_revolution_share.png';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };

  return (
    <div className={styles.shareOverlay}>
      <div className={styles.shareModal}>
        <div className={styles.shareHeader}>
          <h2>Share To Social Media</h2>
          <button className={styles.closeButton} onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" height="28px" viewBox="0 0 24 24" width="28px" fill="#ffffff">
              <path d="M0 0h24v24H0V0z" fill="none"/>
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/>
            </svg>
          </button>
        </div>
        
        <div className={styles.shareContent}>
          <div className={styles.imageWrapper}>
            <div className={styles.shareImageContainer}>
              <canvas 
                ref={canvasRef}
                className={styles.shareImage}
              />
              <button 
                className={styles.downloadIconButton}
                onClick={handleSaveImage}
                aria-label="Download image"
                disabled={!qrCodeGenerated}
              >
                <svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#e3e3e3">
                  <path d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z"/>
                </svg>
              </button>
            </div>
          </div>
          
          <span className={styles.shareText}>
            Your Referral Link:
          </span>
          
          <div 
            className={`${styles.referralCode} ${copied ? styles.copied : ''}`}
            onClick={handleCopy}
            title="Click to copy"
          >
            <div className={styles.codeDisplay}>
              <div className={styles.referralLink}>
                {referralLink}
              </div>
              <svg 
                className={styles.copyIcon}
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2"
              >
                <path d="M16 3H4v13" />
                <path d="M8 7h13v13H8V7z" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Share;
